import React from 'react';
import TextBox from 'devextreme-react/text-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule } from 'devextreme-react/validator';
import Button from 'devextreme-react/button';
// import CheckBox from 'devextreme-react/check-box';
import './index.scss';
import { Link } from 'react-router-dom';

export default class LoginForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            login: '',
            password: ''
        };
        this.login = this.login.bind(this);
    }

    render() {
        const { login, password } = this.state;
        const { appInfo } = this.props;
        return (
            <ValidationGroup
                ref={(ref) => {
                    this.validationGroup = ref ? ref.instance : undefined;
                }}
            >
                <div className={'login-header'}>
                    <div className={'title'}>{appInfo.title}</div>
                </div>
                <div className={'dx-field'}>
                    <TextBox value={login} onValueChanged={this.loginChanged} placeholder={'Tài khoản'} width={'100%'}>
                        <Validator>
                            <RequiredRule message={'Đề nghị nhập Tài Khoản để đăng nhập !'} />
                        </Validator>
                    </TextBox>
                </div>
                <div className={'dx-field'}>
                    <TextBox
                        mode={'password'}
                        value={password}
                        onValueChanged={this.passwordChanged.bind(this)}
                        onEnterKey={this.onEnterKey.bind(this)}
                        placeholder={'Mật khẩu'}
                        width={'100%'}
                    >
                        <Validator>
                            <RequiredRule message={'Đề nghị nhập Mật Khẩu để đăng nhập !'} />
                        </Validator>
                    </TextBox>
                </div>
                <div className={'dx-field'}>
                    <Button type={'default'} text={'ĐĂNG NHẬP'} onClick={this.onLoginClick.bind(this)} width={'100%'} style={{ fontWeight: 500 }} />
                </div>
                <div className={'dx-field'}>
                    <Link to={'/recovery'} onClick={(e) => e.preventDefault()}>
                        Bạn quên mật khẩu ?
                    </Link>
                </div>
            </ValidationGroup>
        );
    }

    loginChanged = (e) => {
        this.setState({ login: e.value });
    };

    passwordChanged = (e) => {
        this.setState({ password: e.value });
    };

    onEnterKey = (e) => {
        this.login();
    };

    onLoginClick = (args) => {
        this.login();
    };

    login = () => {
        if (!this.validationGroup.validate().isValid) {
            return;
        }
        const { login, password } = this.state;
        this.props.onLogin(login, password);

        this.validationGroup.reset();
    };
}
